import { Navigate } from 'react-router-dom'
import { LandingAuthRedirect } from '../components/landing/LandingAuthRedirect'
import { LandingCta } from '../components/landing/LandingCta'
import { LandingFaq } from '../components/landing/LandingFaq'
import { LandingFeatures } from '../components/landing/LandingFeatures'
import { LandingHero } from '../components/landing/LandingHero'
import { LandingHowItWorks } from '../components/landing/LandingHowItWorks'
import { LandingShell } from '../components/landing/LandingShell'
import { LandingUseCases } from '../components/landing/LandingUseCases'
import { LandingWhy } from '../components/landing/LandingWhy'
import { PageSEO } from '../components/seo/PageSEO'
import { LANDING_FAQ } from '../content/landingFaq'
import {
  faqJsonLd,
  organizationJsonLd,
  softwareApplicationJsonLd,
  websiteJsonLd,
} from '../seo/structuredData'
import {
  authConfirmRedirectPath,
  hasEmailConfirmParams,
} from '../lib/authConfirmRedirect'

export function LandingPage() {
  if (hasEmailConfirmParams()) {
    return <Navigate to={authConfirmRedirectPath()} replace />
  }

  return (
    <LandingShell>
      <LandingAuthRedirect />
      <PageSEO
        path="/"
        jsonLd={[
          organizationJsonLd(),
          websiteJsonLd(),
          softwareApplicationJsonLd(),
          faqJsonLd(LANDING_FAQ),
        ]}
      />
      <LandingHero />
      <LandingHowItWorks />
      <LandingFeatures />
      <LandingUseCases />
      <LandingWhy />
      <LandingFaq />
      <LandingCta />
    </LandingShell>
  )
}

export default LandingPage
